export interface IBulkTransaction {
  id?: number;
  importFileUrl?: string | null;
  exportFileUrl?: string | null;
  createdDate?: string;
}

export const defaultValue: Readonly<IBulkTransaction> = {};
